import type { TCoordinate } from './address'

/**
 * @SearchResultDTO will display on the card when user searches
 */
export interface ISearchResultDTO {
  address: {
    city: string | null
    country: string | null
    countryCode: string | null
    postalCode: string | null
    postalCodeSuffix: string | null
    state: string | null
    stateCode: string | null
    street: string | null
    streetNumber: string | null
  }
  /**
   * The address of the place
   */
  addressLabel: string | null
  /**
   * Will be true if the search returns an exact match for the query
   */
  exactMatch: boolean | null
  /**
   *  Will be true if the place already exists in our db
   */
  existingPlace: boolean | null
  /**
   * Represents the GPS coordinates of a place.
   */
  gpsCoordinates: TCoordinate | null
  /**
   * Chaine's unique identifier, if available
   */
  id: string
  /**
   * Google's placeID, each place has a unique identifier
   */
  placeID: string | null
  /**
   * The numerical position in which the place was returned
   */
  position: number | null
  /**
   * The star rating of a place (out of 5)
   */
  rating: number | null
  /**
   * The total number of reviews
   */
  reviews: number | null
  /**
   * The main image of a location
   */
  thumbnail?: string | null
  /**
   * The name of the place
   */
  title: string | null

  /**
   * Type of location (ex: "Warehouse", "Distribution Center")
   */
  type: string[] | null
}

/**
 * The enum to indicate the source from which the stop event was generated
 */
export enum StopSourceEnum {
  AIGenerated = 'AI Generated',
  ChaineWebApp = 'Chaine Web App',
  DriverApp = 'Driver App',
  ExternalIntegration = 'External Integration',
  Geofence = 'Geofence',
  TMSApp = 'TMS App'
}
